import { AdminLayout, DashboardPage } from '@/modules/shared';
import { h } from 'vue';


// Route configuration for admin section
const adminRoutes = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        redirect: { name: 'admin-dashboard' }
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: DashboardPage
      },
      
      // Rotas existentes de empresas
      {
        path: 'companies',
        name: 'admin-companies',
        component: () => import('@/components/company/CompanyList.vue')
      },
      {
        path: 'companies/new',
        name: 'admin-company-create',
        component: () => import('@/components/company/CompanyForm.vue')
      },
      {
        path: 'companies/:id',
        name: 'admin-company-edit',
        component: () => import('@/components/company/CompanyForm.vue'),
        props: true
      },
      {
        path: 'companies/:id/preferences',
        name: 'admin-company-preferences',
        component: () => import('@/components/company/PreferencesForm.vue'),
        props: true
      },
      {
        path: 'companies/:id/branches',
        name: 'admin-company-branches',
        component: () => import('@/components/company/BranchManager.vue'),
        props: true
      },
      {
        path: 'companies/:companyId/branches/:branchId',
        name: 'admin-branch-edit',
        component: () => import('@/components/company/BranchForm.vue'),
        props: true
      },
      {
        path: 'statistics/:companyId?',
        name: 'admin-statistics',
        component: () => import('@/components/NPSStatistics.vue'),
        props: route => ({ companyId: route.params.companyId || null })
      },
      
      // Novas rotas para o sistema de planos
      // Planos
      {
        path: 'plans',
        name: 'admin-plans',
        component: () => import('@/modules/admin-portal/views/PlanList.vue')
      },
      {
        path: 'plans/new',
        name: 'admin-plan-create',
        component: () => import('@/modules/admin-portal/views/PlanForm.vue')
      },
      {
        path: 'plans/:id',
        name: 'admin-plan-edit',
        component: () => import('@/modules/admin-portal/views/PlanForm.vue'),
        props: true
      },
      
      // Templates de Pacotes
      {
        path: 'package-templates',
        name: 'admin-package-templates',
        component: () => import('@/modules/admin-portal/views/PackageTemplateList.vue')
      },
      {
        path: 'package-templates/new',
        name: 'admin-package-template-create',
        component: () => import('@/modules/admin-portal/views/PackageTemplateForm.vue')
      },
      {
        path: 'package-templates/:id',
        name: 'admin-package-template-edit',
        component: () => import('@/modules/admin-portal/views/PackageTemplateForm.vue'),
        props: true
      },
      
      // Agências
      {
        path: 'agencies',
        name: 'admin-agencies',
        component: () => import('@/modules/admin-portal/views/AgencyList.vue')
      },
      {
        path: 'agencies/new',
        name: 'admin-agency-create',
        component: () => import('@/modules/admin-portal/views/AgencyForm.vue')
      },
      {
        path: 'agencies/:id',
        name: 'admin-agency-edit',
        component: () => import('@/modules/admin-portal/views/AgencyForm.vue'),
        props: true
      },
      {
        path: 'agency-purchases',
        name: 'admin-agency-purchases',
        component: () => import('@/modules/admin-portal/views/AgencyPurchaseList.vue')
      },
      {
        path: 'agency-purchases/new',
        name: 'admin-agency-purchase-create',
        component: () => import('@/modules/admin-portal/views/AgencyPurchaseForm.vue')
      },
      // {
      //   path: 'agency-purchases/:id',
      //   name: 'admin-agency-purchase-view',
      //   component: () => import('@/modules/admin-portal/views/AgencyPurchaseDetail.vue'),
      //   props: true
      // },
      
      // Assinaturas
      // {
      //   path: 'subscriptions',
      //   name: 'admin-subscriptions',
      //   component: () => import('@/modules/admin-portal/views/SubscriptionList.vue')
      // },
      // {
      //   path: 'subscriptions/new',
      //   name: 'admin-subscription-create',
      //   component: () => import('@/modules/admin-portal/views/SubscriptionForm.vue')
      // },
      // {
      //   path: 'subscriptions/:id',
      //   name: 'admin-subscription-edit',
      //   component: () => import('@/modules/admin-portal/views/SubscriptionForm.vue'),
      //   props: true
      // },
      
      // Trials
      // {
      //   path: 'trials',
      //   name: 'admin-trials',
      //   component: () => import('@/modules/admin-portal/views/TrialList.vue')
      // },
      
      // Cortesias
      // {
      //   path: 'courtesies',
      //   name: 'admin-courtesies',
      //   component: () => import('@/modules/admin-portal/views/CourtesyList.vue')
      // },
      // {
      //   path: 'courtesies/new',
      //   name: 'admin-courtesy-create',
      //   component: () => import('@/modules/admin-portal/views/CourtesyForm.vue')
      // },
      
      // Pagamentos
      // {
      //   path: 'payments',
      //   name: 'admin-payments',
      //   component: () => import('@/modules/admin-portal/views/PaymentList.vue')
      // },
      // {
      //   path: 'payments/:id',
      //   name: 'admin-payment-detail',
      //   component: () => import('@/modules/admin-portal/views/PaymentDetail.vue'),
      //   props: true
      // },
      
      // Dashboard Financeiro
      // {
      //   path: 'financial-dashboard',
      //   name: 'admin-financial-dashboard',
      //   component: () => import('@/modules/admin-portal/views/FinancialDashboard.vue')
      // },
      // Licenças
      {
        path: 'licenses2',
        name: 'admin-licenses',
        component: () => import('@/modules/admin-portal/views/LicenseList.vue')
      },
      // {
      //   path: 'licenses/activate',
      //   name: 'admin-license-activate',
      //   component: () => import('@/modules/admin-portal/views/LicenseActivationForm.vue')
      // },
      // {
      //   path: 'licenses/:id',
      //   name: 'admin-license-detail',
      //   component: () => import('@/modules/admin-portal/views/LicenseDetail.vue'),
      //   props: true
      // }
    ]
  }
];

export default adminRoutes;